<form class="routed-component-layout" [formGroup]="form" novalidate autocomplete="off">
  <div class="routed-component-body">
    <div class="routed-component-title-block">
      <h2>{{'AUTH.EMAIL_VERIFICATION.TITLE' | translate}}</h2>
      @if (!form?.controls['code']) { <h5>{{'AUTH.EMAIL_VERIFICATION.SUBTITLE' | translate}}</h5> }
    </div>

    @if (oneTimeCodeVerification) {

      <div class="field-group-layout">
        <soldo-field-layout [control]="form.controls['email']" fieldName="email"
            cypressSelector="Signup_TextInput_EntityEmailAddress_ReadOnly"
            label="AUTH.EMAIL_VERIFICATION.WORK_EMAIL_LABEL">

            <input input readonly type="text" name="email" formControlName="email">
        </soldo-field-layout>
      </div>
  
    } @else {

      <soldo-field-layout [control]="form.controls['email']" fieldName="email"
        cypressSelector="Signup_TextInput_EntityEmailAddress"
        label="AUTH.EMAIL_VERIFICATION.WORK_EMAIL_LABEL">

        <input input #codeInput trim="all" type="text" name="email" formControlName="email" (input)="onEmailChange()">

        <ng-container errorMessage>
          <soldo-field-error error errorName="required">{{ 'AUTH.EMAIL_VERIFICATION.EMAIL_REQUIRED' | translate }}</soldo-field-error>
          <soldo-field-error error errorName="invalidEmailFormat">{{ 'WRONG_FORMAT' | translate }}</soldo-field-error>
          <soldo-field-error error errorName="maxlength">
            {{ 'MAX_LENGHT' | translate : { value: form.get('email').errors?.maxlength?.requiredLength} }}
          </soldo-field-error>
          <soldo-field-error error errorName="notYourEmail">{{ 'NOT_YOUR_EMAIL' | translate }}</soldo-field-error>
          <soldo-field-error error errorName="blacklistedDomain">{{
            'AUTH.EMAIL_VERIFICATION.FREE_DOMAIN_ERROR' | translate }}</soldo-field-error>
        </ng-container>
      </soldo-field-layout>

      @if (form?.controls['code']) {
        <p>{{ 'AUTH.EMAIL_VERIFICATION.VERIFICATION_CODE_SUBTITLE' | translate }}</p>
       
        <!-- Verification Code -->
        <ng-container>
          <soldo-field-layout [control]="form.controls['code']" fieldName="code"
            cypressSelector="Signup_TextInput_EntityEmailVerificationCode"
            label="AUTH.EMAIL_VERIFICATION.EMAIL_CODE_LABEL">

            <input trim="all" type="text" inputmode="tel" name="code" formControlName="code" (input)="onCodeInput()" (paste)="onCodeInput()">

            <ng-container errorMessage>
              <soldo-field-error error errorName="required">{{ 'AUTH.EMAIL_VERIFICATION.CODE_REQUIRED' | translate }}</soldo-field-error>
              <soldo-field-error error errorName="pattern">{{ 'WRONG_FORMAT' | translate }}</soldo-field-error>
              <soldo-field-error error errorName="codeMismatch">{{
                'AUTH.EMAIL_VERIFICATION.CODE_MISMATCH' | translate }}</soldo-field-error>
              <soldo-field-error error errorName="maxlength">
                {{ 'MAX_LENGHT' | translate : { value: codeLength } }}
              </soldo-field-error>
            </ng-container>
          </soldo-field-layout>

          <p>{{ 'AUTH.EMAIL_VERIFICATION.RESEND_EMAIL_TITLE' | translate }}<br />
            <button data-cy="Signup_Button_ResendEmailVerificationCode" type="button" class="link no-padding"
              (click)="requestCode()" [disabled]="!resendCodeEnabled">
              {{ 'AUTH.EMAIL_VERIFICATION.RESEND_EMAIL_LINK' | translate }}
            </button>
          </p>
        </ng-container>
      } @else {
        <div class="privacy-notice-box paragraph-group-layout">
          <ng-container>
            
            @if (!isDirectSales) {
              <p class="caption">{{'AUTH.EMAIL_VERIFICATION.PRIVACY_PARAGRAPH_1' | translate }}</p>
              <p class="caption"
                [innerHTML]="'AUTH.EMAIL_VERIFICATION.PRIVACY_PARAGRAPH_2' | translate:{'privacyLink': privacyLink}">
              </p>
            } @else {
              <p class="caption">{{'AUTH.EMAIL_VERIFICATION.PRIVACY_PARAGRAPH_1_DS' | translate }}</p>
              <p class="caption"
                [innerHTML]="'AUTH.EMAIL_VERIFICATION.PRIVACY_PARAGRAPH_2_DS' | translate:{'privacyLink': privacyLink}">
              </p>
            }
          </ng-container>          
        </div>
      }
    }
  </div>

  <!-- Sub-Step Navigation -->
  <div class="routed-component-cta">
      <button type="submit" class="primary" (click)="handleNextStep()" [disabled]="loading" [ngClass]="{ 'loading': loading}"
        data-cy="Signup_Button_NextStepButton">
        {{ 'AUTH.NEXT_SUB_STEP_BUTTON' | translate}}
      </button>
  </div>
</form>